import HeroDesktop from './hero.desktop';
import HeroMobile from './hero.mobile';

export default {
  desktop: HeroDesktop,
  mobile: HeroMobile,
};
